import { render, staticRenderFns } from "./SiLogo.vue?vue&type=template&id=89dd593a&scoped=true&lang=html&"
import script from "./SiLogo.vue?vue&type=script&lang=js&"
export * from "./SiLogo.vue?vue&type=script&lang=js&"
import style0 from "./SiLogo.vue?vue&type=style&index=0&id=89dd593a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89dd593a",
  null
  
)

export default component.exports